import { render, staticRenderFns } from "./VersionEdit.vue?vue&type=template&id=56ae63e2&scoped=true&"
import script from "./VersionEdit.vue?vue&type=script&lang=js&"
export * from "./VersionEdit.vue?vue&type=script&lang=js&"
import style0 from "./VersionEdit.vue?vue&type=style&index=0&id=56ae63e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae63e2",
  null
  
)

export default component.exports